export default "__VITE_ASSET__CUIOvTIg__"